import ApiService from '@/services/orders'

const state = {
    list: {
        current_page: 1,
        data: [],
        item_count: 0,
        last_page: 1,
        links: [],
        per_page: 50,
        total: 0,
    },
    columns: [
        {
            key: 'image',
            visible: true,
        },
        {
            key: 'productInfo',
            visible: true,
        },
        {
            key: 'quantity',
            visible: true,
        },
        {
            key: 'refund',
            visible: true,
        },
        {
            key: 'price',
            visible: true,
        },
        {
            key: 'cog',
            visible: true,
        },
        {
            key: 'feesTaxes',
            visible: true,
        },
        {
            key: 'profitMargin',
            visible: true,
        },
        {
            key: 'profit',
            visible: true,
        },
        {
            key: 'profitPercent',
            visible: true,
        },
    ],
    filterParams: {
        search: null,
        perPage: 50,
        page: 1,
        dateRange: null,
    },
    selectedRows: [],
    isLoadingList: false,
}

const getters = {
    totalPages: (state) => {
        return Math.ceil(state.list.total / state.filterParams.perPage) || 1
    },
}

const mutations = {
    SET_LIST(state, payload) {
        state.list = payload
    },
    SET_COLUMN_TOGGLE(state, index) {
        state.columns[index].visible = !state.columns[index].visible
    },
    SET_COLUMNS(state, payload) {
        state.columns = payload
    },
    SET_FILTER_PARAMS(state, { key, value }) {
        state.selectedRows = []
        state.filterParams[key] = value
    },
    SET_SELECTED_ROW(state, id) {
        const index = state.selectedRows.indexOf(id)
        if (index > -1) {
            state.selectedRows.splice(index, 1)
        } else {
            state.selectedRows.push(id)
        }
    },
    SET_SELECTED_ALL_ROWS(state) {
        if (state.selectedRows.length === state.list.data.length) {
            state.selectedRows = []
            return
        }
        state.selectedRows = state.list.data.map((item) => item.id)
    },
    SET_LOADING_LIST(state, payload) {
        state.isLoadingList = payload
    },
}

const actions = {
    getProducts({ state, commit }, payload) {
        const { loading = true } = payload || {}
        if (loading) {
            commit('SET_LOADING_LIST', true)
        }
        return new Promise((resolve, reject) => {
            ApiService.getProducts(state.filterParams)
                .then((response) => {
                    resolve(response)
                    commit('SET_LIST', response.data)
                })
                .catch((error) => {
                    reject(error)
                })
                .finally(() => {
                    commit('SET_LOADING_LIST', false)
                })
        })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}
